// *************************
// MiniCart
// Add/edit/remove from cart using Fetch and the Shopify Cart API
// https://shopify.dev/api/ajax/reference/cart
// *************************

// add to cart listener
document.addEventListener('click', (event) => {
  const dataEl = event.target.closest('[data-add-to-cart]');

  if (dataEl) {
    // Prevent being redirect to /cart page
    event.preventDefault();

    let qty = dataEl.dataset.productQty || 1;

    if (dataEl.dataset.productType && dataEl.dataset.productType.toLowerCase() === 'pole') {
      const productSelector = document.getElementById('product-select');
      // find selected option on selector
      const selectedOption = productSelector.options[productSelector.selectedIndex];
      const variantTitle = selectedOption.getAttribute('data-variant-title').toLowerCase();

      switch (true) {
        case variantTitle.includes('1 m'):
          qty = Number(qty) * 4;
          break;

        case variantTitle.includes('1.25 m'):
          qty = Number(qty) * 5;
          break;

        case variantTitle.includes('1.50 m'):
          qty = Number(qty) * 6;
          break;

        case variantTitle.includes('1.75 m'):
          qty = Number(qty) * 7;
          break;

        case variantTitle.includes('2 m'):
          qty = Number(qty) * 8;
          break;

        case variantTitle.includes('2.25 m'):
          qty = Number(qty) * 9;
          break;

        case variantTitle.includes('2.50 m'):
          qty = Number(qty) * 10;
          break;

        case variantTitle.includes('2.75 m'):
          qty = Number(qty) * 11;
          break;

        case variantTitle.includes('3 m'):
          qty = Number(qty) * 12;
          break;
      }
    }

    cartFetch('cart/add.js', dataEl.dataset.productId, qty, dataEl.dataset.properties || []);
  }
});

// remove from cart listener
document.addEventListener('click', (event) => {
  const dataEl = event.target.closest('[data-remove-cart-item]');
  if (dataEl) {
    cartFetch('cart/change.js', dataEl.dataset.removeCartItem, 0, '');
  }
});

// update quantity listener
document.addEventListener('click', (event) => {
  const dataEl = event.target.closest('[data-change-cart-item-quantity]');
  if (dataEl) {
    cartFetch('cart/change.js', dataEl.dataset.cartItem, dataEl.dataset.changeCartItemQuantity,'');
  }
});

// Use the AJAX Cart URL to modify the cart data
function cartFetch(cartURL, id, quantity, properties){

  let cartData = {
    id,
    quantity
  };

  if(properties.length) {
    let props = properties.split("|");
    let propsObj = {};

    for (let i = 0; i < props.length; i++) {
      let prop = props[i].split(":");
      
      // let value = prop.slice(1).join(":");

      propsObj[prop[0]] = prop[1];
    }

    cartData.properties = propsObj
  }

  // Use window.Shopify.routes to cover for international markets
  fetch(window.Shopify.routes.root + cartURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartData)
  }).then((response) => {
    //console.log(response);
    getUpdatedCart();
  })
  .catch((error) => {
    console.log(error);
    addToCartFail();
  });
}

// cart add/edit success, dispatch to minicart
function getUpdatedCart() {
  //console.log('get updated cart');
  var customEvent = new CustomEvent('close-modals', {
    bubbles: true,
    cancelable: true,
    detail: {}
  });
  window.dispatchEvent(customEvent);
  var customEvent = new CustomEvent('update-minicart', {
    bubbles: true,
    cancelable: true,
    detail: {}
  });
  window.dispatchEvent(customEvent);
}

// cart failure reporting
function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  console.error('PROBLEM ADDING TO CART!', response.description); 
  var customEvent = new CustomEvent('show-msg', {
    detail: { 
      open: true,
      bgcolor: 'bg-red-500',
      textcolor: 'text-white',
      content: 'Sorry, there has been an error. Please try again later.'
    }
  });
  window.dispatchEvent(customEvent);
}

// *************************
// Check if element exists using mutation observer
// https://gist.github.com/jwilson8767/db379026efcbd932f64382db4b02853e
// *************************
// function elementReady(selector) {
//   return new Promise((resolve, reject) => {
//     let el = document.querySelector(selector);
//     if (el) {resolve(el);}
//     new MutationObserver((mutationRecords, observer) => {
//       Array.from(document.querySelectorAll(selector)).forEach((element) => {
//         resolve(element);
//         observer.disconnect();
//       });
//     })
//     .observe(document.documentElement, {
//       childList: true,
//       subtree: true
//     });
//   });
// }

document.addEventListener('DOMContentLoaded', function () {
  //Collections page
  const productGrid = document.querySelector('#product-grid');
  if (productGrid) {
   
    let mobileView = localStorage.getItem('view');
    if (mobileView == 'double') {
      productGrid.classList.add('grid-cols-2');
    }
    document.addEventListener('show-single', function(event) {
      productGrid.classList.remove('grid-cols-2');
      event.target.parentElement.querySelectorAll('span').forEach((elem)=>{
        elem.classList.remove('bg-black');
        elem.classList.remove('border-black');
      });
      event.target.classList.add('bg-black');
      event.target.classList.add('border-black');
    });
    document.addEventListener('show-double', function(event) {
      productGrid.classList.add('grid-cols-2');
      event.target.parentElement.querySelectorAll('div').forEach((elem)=>{
        elem.classList.remove('bg-black');
        elem.classList.remove('border-black');
      });
      event.target.querySelectorAll('span').forEach((elem)=>{
        elem.classList.add('bg-black');
        elem.classList.add('border-black')
      });
    });
  }

  var animateHTML = function() {
    var elems;
    var windowHeight;
    
    function init() {
      //window.scrollTo(0,0);
      elems = document.querySelectorAll('[data-animate]');
      windowHeight = window.innerHeight;
      addEventHandlers();
      checkPosition();
    }
    
    function addEventHandlers() {
      window.addEventListener('scroll', checkPosition);
      window.addEventListener('resize', init);
    }
        
    function checkPosition() {
      for (var i = 0; i < elems.length; i++) {
        var positionFromTop = elems[i].getBoundingClientRect().top;
        if (positionFromTop - (windowHeight * 0.9) <= 0) {
          elems[i].setAttribute('data-animated', '');
        }
        if ((positionFromTop - windowHeight > 1) || (positionFromTop < 0)) {
          // can be used to reset elements out of view
        }
      }
    }
    
    return {
      init: init
    };
  };
  
  
  if (typeof document !== 'undefined') {
    animateHTML().init();
  };
  
}, false);

//blog functionality

let endCursor = null;
let hasNextPage = true;

const updateProgressBar = (selector, displayedItems) => {
  const progressBar = selector.querySelector('#progress-bar');
  const statusBar = selector.querySelector('#status-bar');
  const totalCount = parseInt(statusBar.getAttribute('data-total-count'));

  statusBar.textContent = `Showing ${displayedItems} of ${totalCount} results`;

  const progressWidth = (displayedItems / totalCount) * 100;
  progressBar.style.width = `${progressWidth}%`;
}

async function getMetaObjWhatevers(templateName, cursor = null, filterValue = null) {
  const paginationOffset = templateName == 'article' ? 20 : 10;
  const objectQuery = cursor => `
      query {
          metaobjects(type: "instagram_images", first: ${paginationOffset} ${cursor ? `, after: "${cursor}"` : ''}) {     
              edges {
                  node {
                      id
                      handle
                      fields {
                          reference {
                              ... on MediaImage {
                                  image {
                                      url
                                  }
                              }
                          }
                          value
                          key
                      }
                  }
              }
              pageInfo {
                  endCursor
                  hasNextPage
              }
          }
      }
  `;

  const options = {
      method: "post",
      headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": '283a901e2f1f97cf46b800537c49cfb6'
      },
      body: objectQuery(cursor)
  };

  try {
      const response = await fetch('https://b7e869-b6.myshopify.com/api/unstable/graphql.json', options);
      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const render = await response.json();
      const metaobjects = render.data.metaobjects;
      endCursor = metaobjects.pageInfo.endCursor;
      hasNextPage = metaobjects.pageInfo.hasNextPage;

      if (templateName === 'article') { 
        return metaobjects.edges.filter(edge => {
          const roomField = edge.node.fields.find(field => field.key === 'room');
          return roomField && roomField.value === filterValue;
        });
      } else return metaobjects.edges;
  } catch (error) {
      console.error('Error fetching meta objects:', error);
      return [];
  }
}

const renderImages = (selectorId, images) => {
  if (images) {
    const selector = document.querySelector(selectorId) || null;
    const parentBlock = selector.querySelector('#parent-block');

    let gridBlock = document.createElement('ul');
        gridBlock.className = 'grid articles list-none px-0 grid-cols-2 md:grid-cols-4 md:grid-rows-2 gap-4 md:gap-8 pb-8';

    images.forEach((edge, index) => {
      const node = edge.node;
      const fields = node.fields;
      const handle = node.handle;
      const imageUrl = fields.find(field => field.key === 'instagram_image').reference.image.url;
      const caption = fields.find(field => field.key === 'instagram_caption').value;
      const caption_color = fields.find(field => field.key === 'show_dark_caption') ? fields.find(field => field.key === 'show_dark_caption').value == 'true' ? 'black' : 'white' : 'white';
      const products = fields.find(field => field.key === 'products') ? fields.find(field => field.key === 'products').value : '';

      console.log(products);

      const li  = `
          <li class="h-full 
              [&:nth-child(10n-9)]:row-span-2  
              [&:nth-child(10n-9)]:col-span-2 
              [&:nth-child(10n-4)]:row-span-2  
              [&:nth-child(10n-4)]:col-span-2 
              md:[&:nth-child(10n-3)]:row-start-3 
              md:[&:nth-child(10n-2)]:row-start-3"> 
            <div class="image-wrapper h-full"> 
                <button type="button" @click="if(${products.length}) setHandle('${handle}')" class="block action-btn p-0 !border-none w-full h-full rounded-lg relative">  
                    <img src="${imageUrl}" width="654" height="654" loading="lazy" class="w-full h-full object-cover rounded-lg" fetchpriority="auto" srcset="" sizes="(max-width: 1800px) calc(100vw - 32px), (min-width: 1832px) 1768px, 1768px">
                    <div class="absolute bottom-0 left-0 w-full">
                      <div class="p-4 text-${caption_color}">${caption}</div>
                    </div>
                </button>
            </div>
          </li> 
      `;
      gridBlock.innerHTML += li;
    });

    parentBlock.appendChild(gridBlock);

    const displayedItems = parentBlock.querySelectorAll('ul.grid li').length;
    updateProgressBar(selector, displayedItems);

    if (!hasNextPage) {
      selector.querySelector('#load-more').style.display = 'none';
    }
  }
}

function galleryDataController(selectorId, templateName, filterValue) {
  document.querySelector(`${selectorId} #load-more`).addEventListener('click', () => {
    if (hasNextPage) {
      getMetaObjWhatevers(templateName, endCursor, filterValue).then(images => {
        renderImages(selectorId, images);
      });
    }
  });
 
  getMetaObjWhatevers(templateName, endCursor, filterValue).then(images => {
    renderImages(selectorId, images);
  });
}


function paginateBlogItems(selectorId) {
  const selector = document.querySelector(selectorId) || null;
  var loadMoreButton = selector.querySelector('#load-more');
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      var nextPageUrl = loadMoreButton.getAttribute('data-next-url');
      fetch(nextPageUrl)
        .then(response => response.text())
        .then(data => {
          var parser = new DOMParser();
          var htmlDoc = parser.parseFromString(data, 'text/html');
          var newArticles = htmlDoc.querySelector(`${selectorId} #article-list .articles`).innerHTML;
          var articleList = document.querySelector(`${selectorId} #article-list .articles`);
          articleList.insertAdjacentHTML('beforeend', newArticles);

          var currentCount = articleList.children.length;
          var totalCount = parseInt(htmlDoc.querySelector('#status-bar').getAttribute('data-total-count'));

          var statusBar = selector.querySelector('#status-bar');
          statusBar.innerHTML = `Showing ${currentCount} of ${totalCount} results`;
          var progressBar = selector.querySelector('#progress-bar');
          if (progressBar) {
            progressBar.style.width = `${(currentCount / totalCount) * 100}%`;
          }

          var newNextButton = htmlDoc.querySelector('#load-more');
          if (newNextButton) {
            loadMoreButton.setAttribute('data-next-url', newNextButton.getAttribute('data-next-url'));
          } else {
            loadMoreButton.remove();
          }
        });
    });
  }
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    document.addEventListener('click', this.handleOutsideClick.bind(this));

    this.querySelectorAll('.country-link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  toggleSelector(event) {
    event.stopPropagation();
    const isHidden = this.elements.panel.hasAttribute('hidden');
    this.elements.panel.toggleAttribute('hidden', !isHidden);
    this.elements.button.setAttribute('aria-expanded', String(!isHidden));
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
    this.hidePanel();
  }
}

customElements.define('localization-form', LocalizationForm);

class QuantityInput extends HTMLElement {
  constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.formatMoney =  this.dataset.moneyFormat; 

      this.querySelectorAll('button').forEach(
          (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  onInputChange(event) {
    this.validateQtyRules();
  }


  async cartFetch(cartURL, id, quantity, properties) {
    const cartData = { id, quantity, properties };
  
    try {
      const response = await fetch(`${window.Shopify.routes.root}${cartURL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartData)
      });
  
      if (!response.ok) throw new Error('Network response was not ok');

  
      const cartResponse = await fetch(`${window.Shopify.routes.cart_url}?section_id=main-cart-items`);
      const responseText = await cartResponse.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const updatedContent = html.querySelector('.cart-items');
      const itemsCount = parseInt(html.querySelector('.items-count').innerHTML);
      
      if(itemsCount!=0){
        document.querySelector('[data-cart-item-count]').innerHTML = itemsCount;
        document.querySelector('[data-cart-item-count]').classList.remove("hidden");
      } else {
        document.querySelector('[data-cart-item-count]').innerHTML = '';
        document.querySelector('[data-cart-item-count]').classList.add("hidden");
      }
  
      document.getElementById('main-cart').innerHTML = updatedContent.innerHTML;
    } catch (error) {
      console.error(error);
      addToCartFail();
    }
  }

  onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      const parentElement = this.input.closest('span'); 

      if (event.target.closest('button').name === 'plus') {
          this.input.stepUp();
      } else if (event.target.closest('button').name === 'minus') {
          this.input.stepDown();
      }

      if (previousValue !== this.input.value) {
          this.input.dispatchEvent(this.changeEvent);
          parentElement.querySelector(".result").innerHTML = this.input.value;
          this.cartFetch('cart/change.js', this.closest('quantity-input').dataset.cartItem, parseInt(this.input.value), '');
      }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);


